export default __webpack_public_path__ + "static/media/ISWEC-15.9db5abcd.pdf";